import {createContext} from "react";
import {User} from "../orval-cml/model/user";

export const UserContext = createContext<User>({} as User);
